const MERCURYX_API = 'https://api.mercuryx.kz/api/v1';

const parseNames = (names) => {
    if (!names) return {};
    if (typeof names === 'string') {
        try { return JSON.parse(names); } catch { return {}; }
    }
    return names;
};

export const getChinaCategories = async (parentId = 0) => {
    const res = await fetch(`${MERCURYX_API}/catalog/category/tree?parent_id=${parentId}`);
    if (!res.ok) throw new Error(`MercuryX API error: ${res.status}`);
    const json = await res.json();
    return (json.data || [])
        .filter(c => c.is_active && !c.is_blocked)
        .map(c => ({
            id: c.id,
            slug: c.slug,
            names: parseNames(c.names),
            products_count: c.products_count || 0,
            image: c.entity?.image && !Array.isArray(c.entity.image) ? c.entity.image : null,
            has_children: !!c.has_children,
            level: c.level,
        }));
};
